import { exitViewAs, useAuthStore } from '../stores/authStore';

// Above every page while Staff views as a User.
export function ViewAsBanner() {
  const viewingAs = useAuthStore((s) => s.viewingAs);
  if (!viewingAs) return null;

  return (
    <div className="view-as-banner" role="status">
      <span>Viewing as {viewingAs.email}. Read-only.</span>
      <button type="button" className="button is-small is-white w-button" onClick={() => exitViewAs(viewingAs.id)}>
        Exit
      </button>
    </div>
  );
}
